import { BATTLESHIP, CALYPSO } from 'HubStyleTokens/colors';
export const ACTION_TOOLBARS = {
  COLUMN: 'COLUMN',
  MODULE: 'MODULE',
  NON_LS_MODULE: 'NON_LS_MODULE',
  ROW: 'ROW',
  TOP_MOST_ROW: 'TOP_MOST_ROW'
};
export const ACTION_TOOLBAR_BUTTONS = {
  CLONE: 'CLONE',
  COLUMN: 'COLUMN',
  DELETE: 'DELETE',
  EDIT: 'EDIT',
  EDIT_LAYOUT: 'EDIT_LAYOUT',
  EDIT_STYLES: 'EDIT_STYLES',
  MAKE_SMART: 'MAKE_SMART',
  MODULE: 'MODULE',
  MOVE: 'MOVE',
  ROW: 'ROW'
};
export const ACTION_TOOLBAR_BUTTON_IMAGE_HEIGHT = 18;
export const ACTION_TOOLBAR_BUTTON_SIZE = 32;
export const ACTION_TOOLBAR_PADDING = 5;
export const CURSORS = {
  DEFAULT: 'DEFAULT',
  GRAB: 'GRAB',
  MOVE: 'MOVE',
  POINTER: 'POINTER'
};
export const DOT = '·';

// Drag preview icon
export const DRAG_ICON_BACKGROUND_COLOR = CALYPSO;
export const DRAG_ICON_INVALID_BACKGROUND_COLOR = BATTLESHIP;
export const DRAG_ICON_INVALID_ICON_OPACITY = 0.75;
export const LINE_FEED = String.fromCharCode(10);

// Drop target colors
export const DROP_TARGET_MAIN_COLOR = '#00a4bd'; // CALYPSO - fill-accent-blue-default
export const DROP_TARGET_OUTLINE_COLOR = '#ffffff'; // OLAF - fill-surface-default
export const DROP_TARGET_DISABLED_COLOR = '#eaf0f6'; // KOALA - fill-primary-disabled